export default "__VITE_ASSET__BCdChuu9__"